import { render, staticRenderFns } from "./LoanDeductions.vue?vue&type=template&id=2ae57ce5"
import script from "./LoanDeductions.vue?vue&type=script&lang=js"
export * from "./LoanDeductions.vue?vue&type=script&lang=js"
import style0 from "./LoanDeductions.vue?vue&type=style&index=0&id=2ae57ce5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports